import { get } from "lodash-es";
import bus from "vue3-eventbus";

import { checkIsMobile } from "@/utils/index";
import { openGoogleMap } from "@/utils/map";
import { initTheme } from "@/utils/theme";
import BookTipDialog from "../../views/hotel/Detail/components/itis/BookTipDialog.vue";
import { useHotelStoreHook } from "../../store/hotel";
import { IChannelConfigs, IChannelTheme } from "../types";
import ITISBackToTop from "./components/Index/backToTop.vue";
import Promotion from "./components/Index/Promotion.vue";
import ITISFooter from "./components/Layout/Footer.vue";
const theme: IChannelTheme = {};

/** 点击rate预订时需要显示提示的酒店品牌 */
const SHOW_CUSTOM_DIALOG_BRAND_GROUP = [
  "617f99c32b7f08462afded45", // 安縵
  "61606b798dec39489e15193e" // dev 凯悦集团
];

export default {
  configs: {
    header: {
      logoAlign: "left"
    },
    currency: "TWD",
    useChannelLogo: true,
    logoUrl:
      "https://qiniu-uploads-cdn.charmdeer.com/FsP3SPw9sbo5IUeLbX2jJnD7yOfB_55.png",
    useChannelLanguages: true,
    showPrivateGender: false,
    components: {
      Footer: {
        component: ITISFooter, // 定制版 Footer
        props: {
          showCopyRight: false
        }
      },
      IndexBackToTop: {
        component: ITISBackToTop,
        props: {
          preventBtn: true
        }
      },
      IndexBeforeFeaturedHotels: {
        component: Promotion
      },
      BookTipDialog: {
        component: BookTipDialog
      }
    },
    pages: {
      Index: {
        logoUrl:
          "https://qiniu-uploads-cdn.charmdeer.com/FsP3SPw9sbo5IUeLbX2jJnD7yOfB_55.png",
        banners: {
          list: [
            {
              img: "https://qiniu-uploads-cdn.charmdeer.com/uploaded/lh6Z3QSSyQNO8JVnfO4tHK8U0_bK/itis-web.png"
            }
          ]
        },
        featuredHotels: [
          "5dc181c6e43c4744226356ea",
          "6756505e12134c242d6dc620",
          "5cd994953e7c2a45504f79d5"
        ],
        specialPromotion: {
          titleI18n: {
            zh_TW: "歡慶網站盛大揭幕，酒店贈禮等你來拿！",
            en: "Celebrating the grand unveiling of the website, hotel gifts await you!"
          },
          subtitleI18n: {
            zh_TW:
              "為了給您更難忘的旅程體驗，\n我們與酒店攜手，\n為您的旅程帶來不一樣的禮遇。",
            en: "To provide you with an unforgettable travel experience, we work closely with hotels to offer you a range of benefits."
          },
          descriptionI18n: {
            zh_TW: "點擊下方「領取專屬禮遇」，即可查看合作酒店與專屬贈禮！",
            en: "Click on 'Get Exclusive Benefits' below to view our partner hotels and the gifts they offer!"
          },
          buttonTextI18n: {
            zh_TW: "領取專屬禮遇",
            en: "Get Exclusive Benefits"
          },
          buttonLink: "https://www.itis.com.tw/limited.php",
          backgroundImage:
            "https://qiniu-uploads-cdn.charmdeer.com/uploaded/FkZVDcupEZ4uz4X2m-I0Wx55aZaz/ITIS_web_home_banner_0917.png"
        },
        rediscoverAsia: {
          loadHotels: false,
          hotelList: [
            {
              images: [
                "https://qiniu-uploads-cdn.charmdeer.com/FvrqyuM51TOitH3uKHiES5dBTwOu_5.jpg"
              ],
              nameI18n: {
                en: "Amankora",
                zh_TW: "Amankora"
              },
              descriptionI18n: {
                en: "Receive up to four complimentary nights for participation in culturally transformative experiences on a journey inspired by Bhutan's dedication to the happiness of its people. Discover the natural beauty and cultural richness of this last remaining Himalayan Buddhist Kingdom and reap the tangible and intangible rewards of giving back.",
                zh_TW:
                  "「快樂王國」、「幸福國度」之稱的不丹，擁有純樸的民風與純淨的自然，快樂不是因為富有，而是珍惜、滿足手邊的幸福。Amankora 是一把打開神秘不丹的鑰匙，由Aman精心安排旅程與餐宿，帶領貴賓體驗最真實、當地的不丹之旅。"
              },
              externalLink: "https://www.itis.com.tw/limited_detail.php?id=62"
            },
            {
              images: [
                "https://qiniu-uploads-cdn.charmdeer.com/Ft1sMGZ_rXWC40H1cAkzbjWpRUeg_5.jpg"
              ],
              nameI18n: {
                en: "Amanjiwo",
                zh_TW: "Amanjiwo"
              },
              descriptionI18n: {
                en: "On stepping into the lounge at Jakarta-Gambir Station, a warm Javanese welcome begins. Throughout the journey guests will enjoy breath-taking views of the Javanese countryside to Yogyakarta.<br />Amanjiwo will provide the catering and the resort's resident anthropologist will share his insights on the historical sites of the Javanese countryside. Guests will arrive at Amanjiwo after a seven-hour journey.",
                zh_TW:
                  "踏上私人列車車廂的一刻，Aman 之旅便啟程了，享受火車上Amanjiwo精心準備的餐點，人類學家為您導覽沿途經過的歷史遺跡，這是抵達婆羅浮屠的最佳方式。"
              },
              externalLink: "https://www.itis.com.tw/limited_detail.php?id=63"
            }
          ]
        }
      },
      prepareOrder: {
        showCancellationPopover: true
      },
      auth: {
        showInvitationCode: true
      }
    },
    footer: {
      show: true
    }
  },
  init() {
    if (checkIsMobile()) {
      window.location.href = "https://itis-m.ytripos.com/";
      return;
    }
    initTheme(theme);
    useHotelStoreHook().searchModel.preferred.currency = this.configs.currency;
  },
  openLocation({ address }) {
    openGoogleMap({
      address
    });
  },
  beforeHotelBook({ hotel, rate }) {
    return new Promise((resolve, reject) => {
      const groupId = get(hotel, "brand.group._id");
      if (SHOW_CUSTOM_DIALOG_BRAND_GROUP.includes(groupId)) {
        bus.emit("showBookTipDialog", { rate });
        reject();
      } else {
        resolve(true);
      }
    });
  }
} as IChannelConfigs;
